import Marquee from "react-fast-marquee";
type Testimonial = {
  name: string;
  image: string;
  quote: string;
};

type TestimonialCarouselProps = {
  data: Testimonial[];
  speed?: number;
};

const TestimonialCarousel = ({
  data,
  speed = 50,
}: TestimonialCarouselProps) => {
  return (
    <div className="w-full">
      <Marquee speed={speed} gradient={false}>
        <div className="gap-3 flex-row flex pl-5">
          {data.map((person, index) => (
            <div
              key={index}
              className="border mt-20 border-[#FFFFFF1F] h-[180px] w-[380px] lg:w-[350px] rounded-md p-6 bg-[#FFFFFF0D]"
            >
              <div className="flex-row flex pb-3 items-center gap-3">
                <img
                  src={person.image}
                  className="size-10 rounded-sm"
                  loading="lazy"
                />
                <h2 className="font-poppins text-white">{person.name}</h2>
              </div>
              <h1 className="text-[#FFFFFFB2] line-clamp-4">
                "{person.quote}"
              </h1>
            </div>
          ))}
        </div>
      </Marquee>
    </div>
  );
};

export default TestimonialCarousel;
